import ButtonSimple from './buttons/ButtonSimple';
import OverlayCount from './OverlayCount';
import OverlayResult from './OverlayResult';
import OverlayResultHide from './OverlayResultHide';
import OverlayExplainer from './OverlayExplainer';
import OverlayElinorTalk from './OverlayElinorTalk';
import OverlayCharactersToHide from './twoplayers/OverlayCharactersToHide';
import OverlayHidingAlert from './twoplayers/OverlayHidingAlert';
import OverlayIconsToHide from './twoplayers/OverlayIconsToHide';
import OverlaySeekingAlert from './twoplayers/OverlaySeekingAlert';
import OverlayPlayerTwoTurn from './twoplayers/OverlayPlayerTwoTurn';
import OverlayEndScreen from './twoplayers/OverlayEndScreen';
import CharactersListSeek from './CharactersListSeek';
import CharactersListHide from './CharactersListHide';
import AnimalIcon from './AnimalIcon';
import ClothesList from './dressup/ClothesList';
import { MODE_SEEK } from '../constants/AppConstants';
import { getGA } from 'analytics/GoogleAnalytics';

export default class GameHud extends Phaser.Group {
  constructor(game, charData) {
    super(game);

    // positioning
    this.game.scale.onSizeChange.add(this.positionContainer, this);

    //
    this.onScrollLeft = new Phaser.Signal();
    this.onScrollRight = new Phaser.Signal();
    this.onCountEnd = new Phaser.Signal();
    this.onCloseResult = new Phaser.Signal();
    this.onCloseExplainer = new Phaser.Signal();
    this.onConfirmHide = new Phaser.Signal(); // dispatched in 'hide' mode after confirmation of hidden characters
    this.onCloseTPOverlay = new Phaser.Signal();
    this.onCloseElinor = new Phaser.Signal();

    this.createScrollArrows();
    this.hideScrollArrows();

    //
    if (this.game.controller.gameMode === MODE_SEEK) {
      this.charactersList = new CharactersListSeek(this.game, charData);
    } else {
      this.charactersList = new CharactersListHide(this.game, charData);
    }
    this.addChild(this.charactersList);
    this.charactersList.x = this.game.width * 0.5;
    this.charactersList.y = 100;

    // create clothes list
    if (this.game.controller.levelData.dress_up) {
      this.createClothesList();
      this.hideClothes();
    }

    //
    this.btnHome = new ButtonSimple({
      game: this.game,
      up: 'btn_home_small',
      down: 'btn_home_small',
    });
    this.btnHome.x = 80;
    this.btnHome.y = 80;
    this.btnHome.onInputDown.add(this.handleBtnHome, this);
    this.addChild(this.btnHome);
  }

  handleBtnHome() {
    let season = this.game.controller.location;
    season = season.replace(/^\w/, (chr) => chr.toUpperCase());
    const label = season + ' Level ' + (this.game.controller.levelId + 1);
    getGA().track({ action: 'Home', label: label });

    //
    this.game.controller.showWelcomeScreen();
  }

  //
  positionContainer() {
    //
    this.btnRight.x = this.game.width - 43;

    //
    if (this.arrowRight) {
      this.arrowRight.x = this.game.width - 140;
    }

    //
    if (this.overlayCount) {
      this.overlayCount.x = (this.game.width - this.game.defaultWidth) * 0.5;
      this.overlayCount.positionElements();
    }

    //
    if (this.overlayResult) {
      this.overlayResult.x = (this.game.width - this.overlayResult.width) * 0.5;
    }

    //
    if (this.overlayElinor) {
      this.overlayElinor.x = (this.game.width - this.game.defaultWidth) * 0.5;
    }

    //
    if (this.overlayTPEndScreen) {
      this.overlayTPEndScreen.x = (this.game.width - this.game.defaultWidth) * 0.5;
      this.overlayTPEndScreen.positionElements();
    }

    //
    if (this.charactersList.parent === this) {
      this.charactersList.x = this.game.width * 0.5 + (this.charactersList.offset || 0);
    }

    if (this.btnContinue) {
      this.btnContinue.x = (this.game.width - this.btnContinue.width) * 0.5;
      this.btnContinue.y = this.game.height - this.btnContinue.height - 50;
    }
  }

  //
  showOverlayCount(characterId, withCircle = true) {
    if (this.game.controller.shortcutsModel.countdownEnabled) {
      this.overlayCount = new OverlayCount(this.game, characterId, withCircle);
      this.addChild(this.overlayCount);
      this.overlayCount.x = (this.game.width - this.overlayCount.width) * 0.5;
      this.overlayCount.onCountEnd.addOnce(this.handleCountEnd, this);
    } else {
      this.onCountEnd.dispatch();
    }
  }

  handleCountEnd() {
    /*
    // hide overlay
    if (this.game.controller.playerMode === PLAYER_TWO) {
      // for 2-players remove counting overlay
      this.removeChild(this.overlayCount);
      this.overlayCount.destroy();
      this.overlayCount = null;
    } else {
      // for 1-player leave overaly with icon
      this.overlayCount.setIcon();
    }
    */

    //
    this.onCountEnd.dispatch();
  }

  removeOverlayCount() {
    this.removeChild(this.overlayCount);
    this.overlayCount.destroy();
    this.overlayCount = null;
  }

  //
  showOverlayResult(seekerId, charsData) {
    this.overlayResult = new OverlayResult(this.game, seekerId, charsData);
    this.addChild(this.overlayResult);
    this.overlayResult.x = (this.game.width - this.overlayResult.width) * 0.5;
    this.overlayResult.onCloseResult.addOnce(this.handleCloseResult, this);
  }

  showOverlayResultHide(charsData, ratings, screenshots) {
    this.overlayResult = new OverlayResultHide(this.game, charsData, ratings, screenshots);
    this.addChild(this.overlayResult);
    this.overlayResult.x = (this.game.width - this.overlayResult.width) * 0.5;
    this.overlayResult.onCloseResult.addOnce(this.handleCloseResult, this);
  }

  handleCloseResult(value) {
    this.onCloseResult.dispatch(value);
  }

  showOverlayElinorTalk(textId, delay) {
    this.overlayElinor = new OverlayElinorTalk(this.game, textId, delay);
    this.addChild(this.overlayElinor);
    this.overlayElinor.x = (this.game.width - this.game.defaultWidth) * 0.5;
    this.overlayElinor.onClose.addOnce(this.handleCloseElinor, this);
  }

  handleCloseElinor() {
    this.overlayElinor.destroy();
    this.overlayElinor = null;
    this.onCloseElinor.dispatch();
  }

  // ---------------------------------------------------------------------------
  // dress up stuff
  // ---------------------------------------------------------------------------
  showDressUp(characterRef, characterId, clothId) {
    characterRef;
    characterId;
    clothId;

    this.clothesList.init(clothId, characterId);
    this.showClothes();
  }

  createClothesList() {
    this.clothesList = new ClothesList(this.game);
    this.clothesList.x = this.game.width * 0.5;
    this.clothesList.y = 60;
    this.addChild(this.clothesList);
  }

  showClothes() {
    this.clothesList.visible = true;
  }

  hideClothes() {
    this.clothesList.visible = false;
  }

  // ---------------------------------------------------------------------------
  // overlays for 2 players mode
  // ---------------------------------------------------------------------------
  showCurrentPlayerIcon(playerIcon, playerNr) {
    if (this.playerIcon) {
      this.playerIcon.destroy();
    }
    this.playerIcon = new AnimalIcon(this.game, 25, 640, playerNr, playerIcon);
    this.playerIcon.scale.set(0.8);
    this.addChild(this.playerIcon);
  }

  showOverlayTPCharacters(characters) {
    const playerIcon = this.game.controller.twoPlayersModel.getHidingPlayerIcon();
    const playerNr = this.game.controller.twoPlayersModel.hidingPlayerId + 1;
    this.overlayTPCharacters = new OverlayCharactersToHide(
      this.game,
      playerIcon,
      playerNr,
      characters
    );
    this.addChild(this.overlayTPCharacters);
    this.overlayTPCharacters.x = (this.game.width - this.game.defaultWidth) * 0.5;
    this.overlayTPCharacters.onEnd.addOnce(this.showOverlayTPHidingAlert, this);
  }

  showOverlayTPHidingAlert() {
    const playerIcon = this.game.controller.twoPlayersModel.getSeekingPlayerIcon();
    const playerNr = ((this.game.controller.twoPlayersModel.hidingPlayerId + 1) % 2) + 1;
    this.overlayTPHidingAlert = new OverlayHidingAlert(this.game, playerIcon, playerNr);
    this.addChild(this.overlayTPHidingAlert);
    this.overlayTPHidingAlert.x = (this.game.width - this.game.defaultWidth) * 0.5;
    this.overlayTPHidingAlert.onEnd.addOnce(this.showOverlayTPIcons, this);
  }

  showOverlayTPIcons() {
    this.overlayTPCharacters.destroy();
    this.overlayTPHidingAlert.destroy();
    this.overlayTPCharacters = null;
    this.overlayTPHidingAlert = null;

    //
    // const playerIcon = this.game.controller.twoPlayersModel.getHidingPlayerIcon();
    const playerNr = this.game.controller.twoPlayersModel.hidingPlayerId + 1;
    this.overlayTPIcons = new OverlayIconsToHide(
      this.game,
      this.playerIcon,
      playerNr,
      this.charactersList
    );
    this.addChild(this.overlayTPIcons);
    this.overlayTPIcons.x = (this.game.width - this.game.defaultWidth) * 0.5;
    this.overlayTPIcons.onEnd.add(this.handleOverlayTPIconsEnd, this);
  }

  handleOverlayTPIconsEnd() {
    this.addChild(this.charactersList);
    this.charactersList.x = this.game.width * 0.5;

    this.addChild(this.playerIcon);
    this.playerIcon.x = 25;

    this.overlayTPIcons.destroy();
    this.overlayTPIcons = null;

    this.onCloseTPOverlay.dispatch();
  }

  showOverlayTPSeekingAlert() {
    const playerIcon = this.game.controller.twoPlayersModel.getSeekingPlayerIcon();
    const playerNr = ((this.game.controller.twoPlayersModel.hidingPlayerId + 1) % 2) + 1;
    this.overlayTPSeekingAlert = new OverlaySeekingAlert(this.game, playerIcon, playerNr);
    this.addChild(this.overlayTPSeekingAlert);
    this.overlayTPSeekingAlert.x = (this.game.width - this.game.defaultWidth) * 0.5;
    this.overlayTPSeekingAlert.onClose.add(this.handleOverlayTPSeekingClose, this);
  }

  handleOverlayTPSeekingClose() {
    this.overlayTPSeekingAlert.onClose.remove(this.handleOverlayTPSeekingClose, this);

    this.overlayTPSeekingAlert.destroy();
    this.overlayTPSeekingAlert = null;

    this.onCloseTPOverlay.dispatch();
  }

  showOverlayTPPlayerTwoTurn() {
    const playerIcon = this.game.controller.twoPlayersModel.getHidingPlayerIcon();
    this.overlayTPPlayerTwoTurn = new OverlayPlayerTwoTurn(this.game, playerIcon);
    this.addChild(this.overlayTPPlayerTwoTurn);
    this.overlayTPPlayerTwoTurn.x = (this.game.width - this.game.defaultWidth) * 0.5;

    this.overlayTPPlayerTwoTurn.onEnd.addOnce(this.hideOverlayTPPlayerTwoTurn, this);
  }

  hideOverlayTPPlayerTwoTurn() {
    this.overlayTPPlayerTwoTurn.destroy();
    this.overlayTPPlayerTwoTurn = null;

    this.onCloseTPOverlay.dispatch();
  }

  showOverlayTPEndScreen() {
    this.overlayTPEndScreen = new OverlayEndScreen(this.game);
    this.addChild(this.overlayTPEndScreen);
    this.overlayTPEndScreen.x = (this.game.width - this.game.defaultWidth) * 0.5;
  }

  // ---------------------------------------------------------------------------
  // scroll arrows
  // ---------------------------------------------------------------------------
  createScrollArrows() {
    this.arrowsContainer = this.game.make.group();
    this.addChild(this.arrowsContainer);

    this.btnLeft = new ButtonSimple({
      game: this.game,
      up: 'arrow_left',
      down: 'arrow_left',
      atlas: 'ui_various',
    });
    this.arrowsContainer.addChild(this.btnLeft);
    this.btnLeft.x = 43;
    this.btnLeft.y = this.game.height * 0.5;
    this.btnLeft.onInputDown.add(this.handleBtnLeftInputDown, this);

    this.btnRight = new ButtonSimple({
      game: this.game,
      up: 'arrow_right',
      down: 'arrow_right',
      atlas: 'ui_various',
    });
    this.arrowsContainer.addChild(this.btnRight);
    this.btnRight.x = this.game.width - 43;
    this.btnRight.y = this.game.height * 0.5;
    this.btnRight.onInputDown.add(this.handleBtnRightInputDown, this);
  }

  showScrollArrows(showLeft = true, showRight = true) {
    if (showLeft) {
      this.btnLeft.visible = true;
    }
    if (showRight) {
      this.btnRight.visible = true;
    }
  }

  hideScrollArrows() {
    this.btnLeft.visible = false;
    this.btnRight.visible = false;
  }

  handleBtnLeftInputDown() {
    this.onScrollLeft.dispatch();
  }

  handleBtnRightInputDown() {
    console.log('handleBtnRightInputDown');
    this.onScrollRight.dispatch();
  }

  // ---------------------------------------------------------------------------
  // continue button in 'hide' mode to confirm location of hidden characters
  // ---------------------------------------------------------------------------
  showContinueButton() {
    this.charactersList.showCheckButton();
  }

  handleContinueDown() {
    this.onConfirmHide.dispatch();
    this.hideContinueButton();
  }

  hideContinueButton() {
    this.charactersList.hideCheckButton();
  }

  // ---------------------------------------------------------------------------
  //
  // ---------------------------------------------------------------------------
  showTargets(targets) {
    targets;
  }

  targetFound(targetId) {
    targetId;
  }

  // ---------------------------------------------------------------------------
  // explainer - LEGACY
  // ---------------------------------------------------------------------------
  showExplainer(bmd, vo, characterId, rating) {
    this.overlayExplainer = new OverlayExplainer(this.game, bmd, vo, characterId, rating);
    this.addChild(this.overlayExplainer);
    this.overlayExplainer.onClick.addOnce(this.handleExplainerClick, this);
  }

  handleExplainerClick() {
    this.overlayExplainer.destroy();
    this.overlayExplainer = null;
    this.onCloseExplainer.dispatch();
  }

  // ---------------------------------------------------------------------------
  // arrow for onboarding
  // ---------------------------------------------------------------------------
  showScrollArrow(side, enabled) {
    let arrow = this.btnLeft;
    if (side === 'right') {
      arrow = this.btnRight;
    }
    arrow.visible = true;
    arrow.input.enabled = enabled;
  }

  hideScrollArrow(side, enabled) {
    let arrow = this.btnLeft;
    if (side === 'right') {
      arrow = this.btnRight;
    }
    arrow.visible = false;
    arrow.input.enabled = enabled;
  }

  setScrollArrowState(side, state) {
    let arrow = this.btnLeft;
    if (side === 'right') {
      arrow = this.btnRight;
    }

    if (state === 'active') {
      arrow.scale.set(1.2);
    } else {
      arrow.scale.set(1);
    }
  }

  lockArrows() {
    this.arrowsLocked = true;
    this.btnLeft.input.enabled = false;
    this.btnRight.input.enabled = false;
  }

  unlockArrows() {
    this.arrowsLocked = false;
    this.btnLeft.input.enabled = true;
    this.btnRight.input.enabled = true;
  }

  // ---------------------------------------------------------------------------
  // clean up
  // ---------------------------------------------------------------------------
  destroy() {
    this.game.scale.onSizeChange.remove(this.positionContainer, this);

    this.btnHome.onInputDown.remove(this.handleBtnHome, this);
    this.onScrollLeft.removeAll();
    this.onScrollRight.removeAll();
    this.onScrollLeft = null;
    this.onScrollRight = null;

    this.overlayTPEndScreen = null;
    super.destroy();
  }
}
